import axios from './api'
const orderServer = {	
	SearchOrder(params) {
		return axios.post(`app/require/page`, params).then((res) => {
            return res.data
        })
	},
	SearchOrderInfo(params) {
		return axios.post(`app/require/detail`, params).then((res) => {
            return res.data
        })
	},
	BuyOrder(params) {
		return axios.post(`app/kkOrder/buy`, params).then((res) => {
            return res.data
        })
	},
	quitOrder(params) {
		return axios.post(`app/kkOrder/order/refund`, params).then((res) => {
            return res.data
        })
	},
	AuthStatus(params) {
		return axios.post(`user/auth/getStatus`, params).then((res) => {
            return res.data
        })
	},
	SearchBanner(params) {
		return axios.post(`app/banner/listAll`, params).then((res) => {
            return res.data
        })
	},
	PostFull(params) {
		return axios.post(`app/wallet/recharge/submit`, params).then((res) => {
            return res.data
        })
	},
	Maps(longitude,latitude) {
		return axios.post(`https://restapi.amap.com/v3/geocode/regeo?key=34d711b66761bb30efd5e9e87cc7016f&location=${longitude},${latitude}`, {}).then((res) => {
            return res.data
        })
	},
	SearchVersion(params) {
		return axios.post(`app/version/query`, params).then((res) => {
            return res.data
        })
	},

	
}

export default orderServer


// WEBPACK FOOTER //
// ./src/api/order.js